module.exports = "<div class=\"menu-name-faq\" id=\"mainInfoFaqDiv\" ng-init=\"vm.keyWatch($event)\">\n  <span class=\"myAccount-grey\"> /</span>\n  <span>{{vm.name}}</span>\n</div>\n\n<div>\n  <tutoriallist list-id=\"navigation\" items=\"vm.menuitems\" btn-class=\"btn btn-faq btn-main-nav\"></tutoriallist>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/faq/faq.html
// module id = 163
// module chunks = 0